import type { SxProps, Theme } from '@mui/material';
import { osirisTokens } from '@/theme/tokens';

/**
 * Standard sx for icon buttons inside TableRowActions (32px, purple hover per design)
 */
export const tableRowActionButtonSx: SxProps<Theme> = {
  width: 32,
  height: 32,
  borderRadius: '1px',
  // Figma row-action cell: light fill + near-white 20px icon
  bgcolor: 'rgba(255, 255, 255, 0.12)',
  color: osirisTokens.icons.primary,
  '& svg': { fontSize: 20 },
  '&:hover': {
    bgcolor: osirisTokens.bg.active,
    color: osirisTokens.icons.primary,
  },
  '&.Mui-disabled': { opacity: 0.3 },
};

/**
 * Expandable List hover states (Figma 28301:55628) — mission commands,
 * equipment, certificate and trigger-rule rows. The 2px accent bar is an inset
 * shadow so hovering doesn't shift the row content.
 */
export const expandableRowHoverSx = {
  transition: 'box-shadow 100ms ease',
  '&:hover': { boxShadow: `inset 2px 0 0 ${osirisTokens.accent.main}` },
};

/** Row chip action (expand, regenerate…): accent fill on hover */
export const expandableChipHoverSx = {
  '&:hover': { bgcolor: osirisTokens.bg.active, color: '#ffffff' },
};

/** Row delete chip: Bg/bg-error fill on hover */
export const expandableDeleteHoverSx = {
  '&:hover': { bgcolor: '#d01b3a', color: '#ffffff' },
};
